import { INLEAGUE_STATUS_PAGE, useInleagueHealth } from '../lib/inleagueStatus'
import { NOTICE_CLASS } from './notice'

/** "InLeague is not responding", at the top of every signed-in page while
 *  InLeague refuses us (spec 2026-10-07). Each app's AppShell renders it first
 *  inside ContentMain, and appShellLandmarks.test.ts holds that. Renders
 *  nothing until a poll says InLeague is down, so the page never shifts when
 *  all is well. `role="status"` so a screen reader is told once, not on every
 *  poll. Bold because it is a true warning. `hostname` is a parameter only so
 *  tests can pass one. */
export function InleagueStatusBanner({
  hostname = window.location.hostname,
  className = '',
}: {
  hostname?: string
  className?: string
}) {
  if (!useInleagueHealth(hostname).down) return null
  return (
    <p role="status" className={`${NOTICE_CLASS} font-bold m-0 ${className}`.trim()}>
      InLeague is not responding right now. Anything that reads from or saves to InLeague may fail until it
      recovers. Check{' '}
      <a href={INLEAGUE_STATUS_PAGE} target="_blank" rel="noopener noreferrer" className="text-ink underline">
        status.ayso13.org
      </a>{' '}
      for updates.
    </p>
  )
}
